import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import router from '@/router'
import store from '@/store'

// 创建axios实例
const service = axios.create({
  baseURL: 'https://attendance.ahutit.com/api', // api的base_url
  // baseURL: 'http://localhost:8080/api', // api的base_url
  timeout: 10000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error)
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果自定义代码不是200，则判断为错误
    if (res.code !== 200) {
      if (res.code === 401) {
        MessageBox.confirm(
          '登录状态已过期，请重新登录',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.commit('CLEAR_LOGIN_INFO')
          router.push('/login')
        })
      }
      
      // 将后端返回的数据附加到错误对象，便于业务层解析
      const err = new Error(res.msg || 'Error')
      err.response = res
      return Promise.reject(err)
    } else {
      return res
    }
  },
  error => {
    const status = error && error.response && error.response.status
    if (status === 401 || status === 403) {
      store.commit('CLEAR_LOGIN_INFO')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

export default service